"use client";

import { useState, useEffect } from "react";
import { useRouter } from "next/navigation";
import LoaderFullScreen from "@/app/src/components/common/LoaderFull";

export default function ProtectedRoute({ children }) {
    const router = useRouter();
    const [isCheckingAuth, setIsCheckingAuth] = useState(true);

    useEffect(() => {
        const localAuthToken = localStorage.getItem("token");

        if (!localAuthToken) {
            router.replace("/login");
            return;
        }

        setIsCheckingAuth(false);
    }, [router]);

    if (isCheckingAuth) {
        return <LoaderFullScreen />;
    }

    return children;
}
